// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"ad8991f3","788":"987f02c5"}[chunkId] + ".chunk.js";
};